import { useState, useRef, useEffect } from 'react';
import LinkComponent from './LinkComponent';

const Download = ({
  linkTitletxt,
  linkTitleDocs,
  handleDownload,
  downloadDocxFile,
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  const openDropdown = () => {
    setDropdownOpen(true);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  const handleTextClick = () => {
    handleDownload();
    closeDropdown();
  };

  const handleDocsClick = () => {
    downloadDocxFile();
    closeDropdown();
  };

  return (
    <>
      <div
        id="download-dropdown-container"
        className="inline-block text-left"
        ref={dropdownRef}
      >
        <div id="download-button-container">
          <button
            id="download-dropdown-button"
            name="download.dropdown"
            data-testid="download-dropdown-button"
            type="button"
            className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-3 text-sm font-semibold text-gray-900 shadow-md ring-1 ring-inset ring-gray-300 hover:bg-blue-100"
            aria-expanded={isDropdownOpen}
            aria-haspopup="true"
            onClick={openDropdown}
          >
            Download

            <svg
              id="download-dropdown-icon"
              className="-mr-1 h-5 w-5 text-gray-400"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>

        {isDropdownOpen && (
          <div
            id="download-dropdown-menu"
            data-testid="download-dropdown-menu"
            className="absolute right-4 z-10 mt-2 w-44 ml-10 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="download-dropdown-button"
            tabIndex="-1"
          >
            <div
              id="download-dropdown-items"
              className="py-1"
              role="none"
            >
              <LinkComponent
                id="download-text-link"
                name="download.text"
                data-testid="download-text-link"
                linkTitle={linkTitletxt}
                handleOnClick={handleTextClick}
              />

              <LinkComponent
                id="download-docx-link"
                name="download.docx"
                data-testid="download-docx-link"
                linkTitle={linkTitleDocs}
                handleOnClick={handleDocsClick}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Download;